import React from 'react';
import CensusSection from '../Common/CensusSection';
import ThemeMap from '../Theme/ThemeMap';

const People = () => (
    <CensusSection
        menuPath="people"
        pages={[
            { path: 'demography', title: 'Demografia', element: <ThemeMap theme="demografia" /> },
            { path: 'race', title: 'Cor/Raça', element: <ThemeMap theme="cor_raca" /> },
            { path: 'literacy', title: 'Alfabetização', element: <ThemeMap theme="alfabetizacao" /> },
            { path: 'kinship', title: 'Parentesco', element: <ThemeMap theme="parentesco" /> },
            { path: 'deaths', title: 'Óbitos', element: <ThemeMap theme="obitos" /> }
        ]}
    />
);

export default People;
